/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to check DNS text record
 * @export
 * @interface CheckDNSRecordRequest
 */
export interface CheckDNSRecordRequest {
    /**
     * Org emails domain
     * @type {string}
     * @memberof CheckDNSRecordRequest
     */
    domain?: string;
    /**
     * Expected TXT record that should be found in DNS records
     * @type {string}
     * @memberof CheckDNSRecordRequest
     */
    expectedTxtRecord?: string;
}

/**
 * Check if a given object implements the CheckDNSRecordRequest interface.
 */
export function instanceOfCheckDNSRecordRequest(value: object): boolean {
    return true;
}

export function CheckDNSRecordRequestFromJSON(json: any): CheckDNSRecordRequest {
    return CheckDNSRecordRequestFromJSONTyped(json, false);
}

export function CheckDNSRecordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckDNSRecordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'] == null ? undefined : json['domain'],
        'expectedTxtRecord': json['expectedTxtRecord'] == null ? undefined : json['expectedTxtRecord'],
    };
}

export function CheckDNSRecordRequestToJSON(value?: CheckDNSRecordRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'domain': value['domain'],
        'expectedTxtRecord': value['expectedTxtRecord'],
    };
}

